import { EyeInvisibleOutlined, EyeOutlined } from 'components/icons';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from 'components/ui/input-group';
import { ComponentProps } from 'react';
import { t } from 'utils/getTranslations';

type Props = Omit<ComponentProps<'input'>, 'type'> & {
    visible: boolean;
    onToggleVisible: () => void;
};

/** A password field with the show/hide toggle at its end. */
export function PasswordInput({ visible, onToggleVisible, ...inputProps }: Props) {
    return (
        <InputGroup>
            <InputGroupInput {...inputProps} type={visible ? 'text' : 'password'} />
            <InputGroupAddon align="inline-end">
                <InputGroupButton
                    size="icon-sm"
                    aria-label={t('auth.show-password')}
                    aria-pressed={visible}
                    className="text-primary hover:text-primary"
                    onClick={onToggleVisible}
                    // Keeps the focus in the field while the toggle is clicked.
                    onMouseDown={(event) => event.preventDefault()}
                >
                    {visible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                </InputGroupButton>
            </InputGroupAddon>
        </InputGroup>
    );
}
